import { Check } from "lucide-react";

const ABOUT_IMG =
    "/api/files/ahamyog/uploads/69f989670ba470660424bfea/6aea447c-b3c6-4b78-9f58-979fa74797cd.jpg";

const PILLARS = [
    "Yoga Classes for All Levels",
    "Teacher Training Programs",
    "Workshops and Retreats",
    "Online Yoga Sessions",
];

export default function AboutSection() {
    return (
        <section
            id="about"
            className="py-20 md:py-28 relative"
            data-testid="about-section"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
                <div className="lg:col-span-6 relative">
                    <div className="aspect-[4/5] max-w-md mx-auto rounded-3xl overflow-hidden shadow-soft">
                        <img
                            src={ABOUT_IMG}
                            alt="Aham Yog Institute studio"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    {/* floating ring */}
                    <div className="absolute -top-6 -left-6 h-32 w-32 rounded-full border-[6px] border-brand-200/70 hidden md:block" />
                    <div className="absolute -bottom-6 right-12 h-20 w-20 rounded-full bg-accent-100 hidden md:block" />
                    {/* sticker card */}
                    <div className="absolute bottom-8 -right-2 md:right-8 bg-white rounded-2xl shadow-soft border border-gray-100 px-5 py-4 max-w-[230px]">
                        <div className="font-heading text-3xl font-semibold text-brand-600">
                            12+
                        </div>
                        <div className="text-xs text-ink-700 leading-snug">
                            Years guiding students through breath, movement & stillness.
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-6">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 text-xs font-semibold tracking-wide uppercase">
                        Your Pathway to Holistic Well-being
                    </span>
                    <h2 className="mt-5 text-4xl md:text-5xl font-heading font-semibold tracking-tight text-ink-900 leading-tight">
                        Welcome to {" "}
                        <span className="text-brand-500">Aham</span> Yoga{" "}
                        <span className="text-accent-500">Institute</span>.
                    </h2>
                    <p className="mt-6 text-lg text-ink-700 leading-relaxed">
                        At Aham Yoga Institute, we are dedicated to guiding individuals on a transformative journey towards physical, mental, and
spiritual well-being through the ancient practice of yoga. Rooted in tradition yet tailored for the modern world, our institute
offers a sanctuary where you can explore, learn, and deepen your yoga practice in a nurturing environment.
                    </p>

                    <ul className="mt-8 grid sm:grid-cols-2 gap-3">
                        {PILLARS.map((p) => (
                            <li key={p} className="flex items-start gap-2.5 text-sm text-ink-900">
                                <span className="mt-0.5 h-5 w-5 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
                                    <Check className="h-3.5 w-3.5" strokeWidth={2.6} />
                                </span>
                                <span>{p}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
